import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=51ed8671&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=ts"
export * from "./ImagePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed8671",
  null
  
)

export default component.exports